import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import animationData from '../Assets/career-loader-animation.json';

const CareerLoader = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/career-progress');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-white/80 backdrop-blur-md rounded-[30px] shadow-xl p-6 flex flex-col justify-center items-center min-h-[75vh] w-full max-w-[950px] mx-auto">
      <div className="w-[300px] md:w-[400px] lg:w-[500px]">
        <Lottie animationData={animationData} loop={true} />
      </div>
      <p className="text-lg md:text-xl font-semibold text-stone-800 font-sora text-center mt-6">
        Kumar is figuring out your personalized career roadmap...{' '}
        <span role="img" aria-label="rocket">🚀</span>
      </p>
    </div>
  );
};

export default CareerLoader;
